import { useState } from 'react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useDeleteAllocation } from '@/hooks/useAllocations'

interface DeleteAllocationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  allocationId: string
  allocationName?: string
}

export function DeleteAllocationDialog({
  open,
  onOpenChange,
  allocationId,
  allocationName,
}: DeleteAllocationDialogProps) {
  const [isDeleting, setIsDeleting] = useState(false)
  const deleteMutation = useDeleteAllocation()

  const handleDelete = async () => {
    setIsDeleting(true)
    try {
      await deleteMutation.mutateAsync(allocationId)
      onOpenChange(false)
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Allocation</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete the allocation for{' '}
            <span className="font-semibold">{allocationName || 'this aircraft'}</span>? This
            action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex justify-end gap-2">
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete} disabled={isDeleting} className="bg-destructive">
            {isDeleting ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  )
}
